document.querySelectorAll('[data-search-page-form]').forEach(form => {
  const input = form.querySelector('input[type="search"]');
  const resetButton = form.querySelector('[data-search-page-reset]');

  if (!input || !resetButton) return;

  const updateResetButton = () => {
    resetButton.classList.toggle('search__active', input.value.trim().length > 0);
  };

  input.addEventListener('input', updateResetButton);
  resetButton.addEventListener('click', () => {
    input.value = '';
    updateResetButton();
    input.focus();
  });

  updateResetButton();
});
